import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import NitrogenPlantDetailsTable from "../../components/CargoCraneCom/NitrogenPlantRow";

function StaffNitrogenPlant({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchNitrogenPlantList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_cargo_machinery_nitrogen_plant_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.nitrogen_parameters_data || []);
      }
    } catch (error) {
      console.error("Error fetching Nitrogen Plant list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchNitrogenPlantList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Nitrogen Plant Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <NitrogenPlantDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffNitrogenPlant;
